import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  .ant-picker {
    width: 100%;
    height: 100%;
    border: none;
    padding: 0;
  }
`;
